<script lang="ts" setup>
	import { useI18n } from 'vue-i18n'

	const { t: _tr } = useI18n()
</script>

<template>
	<div class="card from-primary/10 via-primary/5 to-base-100 border-primary/10 border bg-gradient-to-r shadow-sm">
		<div class="card-body">
			<div class="text-base-content/60 text-xs tracking-wide uppercase">{{ _tr('profile.account') }}</div>
			<div class="card-title leading-tight">{{ _tr('profile.title') }}</div>
			<p class="text-base-content/70 text-sm">{{ _tr('profile.subtitle') }}</p>
		</div>
	</div>
</template>
